export default __webpack_public_path__ + "static/media/01.ad8fb346.jpg";